import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["LotAssignmentModal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close,
    onConfirm: $setup.confirm
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "text-semi-bold" }, "Confirm action", -1)
    ]))]),
    description: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString($setup.text) + " ", 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString($props.deleteItem), 1),
      ($setup.isLeadsPage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " " + _toDisplayString($props.deleteItem > 1 ? "leads" : "lead"), 1))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createTextVNode("?", -1))
    ]),
    _: 1
  }, 8, ["is-open"]))
}